// lazy-core.js — Fate Skincare advanced optimization
(function(){
  const vendors = [
    'https://www.googletagmanager.com/gtag/js?id=G-7MX643T25R',
    'https://cdn.shopify.com/extensions/f88b1bf2-73bf-40b2-b60e-1692bf5652b0/inbox-1251/assets/ShopifyChatV1Widget.js',
    'https://subscription-admin.appstle.com/assets/js/appstle-subscription.min.js',
    'https://connect.facebook.net/en_US/fbevents.js'
  ];

  function deferScript(src){
    if(document.querySelector(`script[src*="${src}"]`)) return;
    const s=document.createElement('script');
    s.src=src; s.async=true; s.defer=true;
    document.body.appendChild(s);
  }

  function onFirstInteraction(){
    vendors.forEach(deferScript);
    window.removeEventListener('scroll', onFirstInteraction);
    window.removeEventListener('mousemove', onFirstInteraction);
    window.removeEventListener('touchstart', onFirstInteraction);
  }

  window.addEventListener('scroll', onFirstInteraction, { once:true });
  window.addEventListener('mousemove', onFirstInteraction, { once:true });
  window.addEventListener('touchstart', onFirstInteraction, { once:true });

  // Safety fallback: load everything after 6 seconds idle
  setTimeout(() => vendors.forEach(deferScript), 6000);
})();
